module.exports = __webpack_public_path__ + "img/share-icon.5c3c54ab.svg";